import MandalaDivider from "@/components/MandalaDivider";

interface PullQuoteSceneProps {
  quote: string;
  attribution?: string;
  kicker?: string;
}

export default function PullQuoteScene({ quote, attribution, kicker }: PullQuoteSceneProps) {
  return (
    <section
      className="home-band home-band--quiet relative px-5 sm:px-8 texture-grain"
      style={{ background: "hsl(var(--ink))" }}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 55% 40% at 50% 50%, hsl(var(--marigold) / 0.06), transparent 70%)",
        }}
      />

      <div className="relative z-10 w-full max-w-4xl mx-auto flex flex-col items-center text-center">
        <div className="scroll-reveal">
          <MandalaDivider ruleWidth={90} size={26} />
        </div>

        {kicker && (
          <p className="scroll-reveal mt-6 section-eyebrow">{kicker}</p>
        )}

        <blockquote
          className="scroll-reveal pull-quote font-display mt-6"
          dangerouslySetInnerHTML={{
            __html: quote.replace(
              /<em>(.*?)<\/em>/g,
              `<em style="color: hsl(var(--marigold)); font-style: italic;">$1</em>`,
            ),
          }}
        />

        {attribution && (
          <p
            className="scroll-reveal mt-6 font-display italic text-manuscript/55"
            style={{ fontSize: "clamp(0.9rem, 1.1vw, 1.05rem)" }}
          >
            — {attribution}
          </p>
        )}

        <div className="scroll-reveal mt-8">
          <MandalaDivider ruleWidth={90} size={26} />
        </div>
      </div>
    </section>
  );
}
